import { allow } from '../classes/allow';
import dateFieldValue from '../objects/models/date.field.value';
import addLeadingZeroes from './add.leading.zeroes';

export default function getDateStringFromObject(dateObject = {}) {
    allow.anInstanceOf(dateObject, dateFieldValue);
    return `${dateObject.year}-${addLeadingZeroes(+dateObject.month, 2)}-${addLeadingZeroes(+dateObject.day, 2)}`;
}
